import { useEffect } from 'react';

import { addDays } from 'date-fns'

import { parseData, subsetData, getUniqueValues } from './utils';
import rawdata from '../assets/data.json';
import dateData from '../assets/datedata.json';


import { useSelector, useDispatch } from 'react-redux';
import { setWeek } from '../redux/chooseWeekSlice';
import { setData } from '../redux/rawDataSlice';
import { setItems } from '../redux/chooseItemsSlice';
import { setItemGroups } from '../redux/chooseItemGroupSlice';
import { setDateData } from '../redux/dateDataSlice';



const LoadData = ({dataLoaded, setDataLoaded}) => {

    const filterOnNewest = (data) => {
        if (data.keys != null){     
            // filter the tariefomschrijving to only one in the list and choose the newest
            const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
            let temp = []
            ig.forEach((ig) => {
                const subset = subsetData(data, ig, 'TARIEFGROEPOMSCHRIJVING')
                const unique = getUniqueValues(subset, 'TARIEFOMSCHRIJVING')
                unique.forEach((u) => {
                    const subset2 = subsetData(subset, u, 'TARIEFOMSCHRIJVING')
                    const newest = subset2.reduce((a, b) => a.DATUM > b.DATUM ? a : b)
                    temp.push(newest)
                })
            })
            return temp
        }
    }
    
    
    const setRawDataToLowerCase = (data) => {
        if (data.keys != null){
            let temp = []
            data.forEach((item) => {
                temp.push({
                    TARIEFOMSCHRIJVING: item.TARIEFOMSCHRIJVING.toLowerCase(),
                    VRIJEVOORRAAD: Math.floor(item.VRIJEVOORRAAD),
                    DATUM: item.DATUM,
                    TARIEFGROEPOMSCHRIJVING: item.TARIEFGROEPOMSCHRIJVING
                })
            })
            return temp
        }
    }

    

    const rdata = useSelector(state => state.rawData.value)

    const dispatch = useDispatch();

    // Init states
    // Init the week state
    const current = new Date();
    const pastMonth = new Date(current.getFullYear(), current.getMonth(), current.getDate());

    const defaultSelected = {
        from: pastMonth.getTime(),
        to: addDays(pastMonth, 7).getTime()
    };

    
    useEffect(() => {
        dispatch(setWeek(defaultSelected))
    }, [])

    // ----------------------------------------

    // Init the dateData state
    useEffect(() => {
        // set All the tariefomschrijving value to lowercase

        if (dateData.keys != null){
            const temp = []
            dateData.forEach((item) => {
                temp.push({
                    datum: item.datum,
                    aantal: 1,
                    project: item.project,
                    tariefgroepomschrijving: item.tariefgroepomschrijving,
                    tariefomschrijving: item.tariefomschrijving.toLowerCase()
                })
            })
        dispatch(setDateData(temp))
        }
    }, [])

    // Init the rawdata state
    useEffect(() => {
        const url = 'https://werkvoorbereiding.divoduurzaam.nl/assets/php/tunnel/?file=itemstockdata.php'

        fetch(url)
        .then(response => response.json())
        .then(data => {
            const filteredData = filterOnNewest(data)
            const lowerCaseData = setRawDataToLowerCase(filteredData)
            dispatch(setData(lowerCaseData))
            setDataLoaded(true)
        })
    }, [])
        


    // ----------------------------------------
    // Init the chooseItem state

    const data = useSelector(state => state.rawData.value)
        
    useEffect(() => {
        if (data.keys != null){     
            const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
            let temp = {}
            ig.forEach((ig) => {
                temp[ig] = {}
                subsetData(data, ig, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                    temp[ig][item.TARIEFOMSCHRIJVING] = false
                })
            })
            dispatch(setItems(temp))
        }

    }, [data])

    useEffect(() => {
        if (data.keys != null){
            const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
            let temp = {}
            ig.forEach((ig) => {
                temp[ig] = false
            })
            dispatch(setItemGroups(temp))
    }
    }, [data])



}

export default LoadData